const WhyUsSection = () => {
  const features = [
    {
      id: 1,
      number: '01',
      title: 'Güvenilir Hizmet',
      description: '15 yılı aşkın deneyimimizle 2. el bilgisayar alım satım ve teknik servis hizmetlerinde güvenilir çözümler sunuyoruz.',
    },
    {
      id: 2,
      number: '02',
      title: 'Uygun Fiyat',
      description: 'İkinci el bilgisayar ve laptop tamiri hizmetlerimizde piyasanın en uygun fiyatlarını sunuyoruz. Şeffaf fiyatlandırma garantisi.',
    },
    {
      id: 3,
      number: '03',
      title: 'Hızlı Servis',
      description: 'Bilgisayar tamiri ve masaüstü bilgisayar tamiri işlemlerinizi aynı gün içinde tamamlıyoruz. Acil servis desteği mevcuttur.',
    },
    {
      id: 4,
      number: '04',
      title: 'Uzman Kadro',
      description: 'Notebook tamiri, format atma, anakart tamiri ve ekran değişimi konularında uzman teknik ekibimiz her zaman yanınızda.',
    },
    {
      id: 5,
      number: '05',
      title: 'Garanti',
      description: 'Tüm bilgisayar bakım ve onarım hizmetlerimizde 12 ay garanti veriyoruz. Orijinal parça kullanımı garantisi.',
    },
    {
      id: 6,
      number: '06',
      title: 'Kurumsal Destek',
      description: 'Oyuncu bilgisayarı tamiri ve kurumsal bilgisayar servisi için özel paketlerimiz ile işletmenize destek oluyoruz.',
    },
  ];

  return (
    <section className="py-24 bg-neutral-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Content */}
          <div className="lg:col-span-2">
            <div className="inline-block px-4 py-2 bg-secondary/10 rounded-full mb-6">
              <span className="text-secondary font-semibold text-sm">Neden ES Bilgisayar?</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-6 leading-tight font-heading">
              Güvenilir Teknoloji Çözüm Ortağınız
            </h2>
            <p className="text-neutral-600 text-base leading-relaxed">
              2. el bilgisayar alım satım, ikinci el laptop, bilgisayar tamiri ve laptop tamiri konularında uzman kadromuz ile hizmetinizdeyiz. Uygun fiyatlı ikinci el bilgisayar seçenekleri ve profesyonel teknik servis desteği için doğru adrestesiniz.
            </p>
          </div>

          {/* Right Grid */}
          <div className="lg:col-span-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature) => (
                <div
                  key={feature.id}
                  className="bg-white rounded-xl p-6 shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-1 group"
                >
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-accent/10 rounded-lg text-accent font-bold text-lg group-hover:bg-accent group-hover:text-white transition-colors">
                      {feature.number}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-primary mb-2">{feature.title}</h3>
                      <p className="text-neutral-600 text-sm leading-relaxed">{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;